import React, {useCallback, useLayoutEffect, useRef, useState} from 'react';
import {createPortal} from "react-dom";
import usePolDropdown from "v4/components/ui/PolDropdown/hooks/usePolDropdown";
import './PolDropdown.scss';
import PolDropdownDetails from "v4/components/ui/PolDropdown/components/PolDropdownDetails/PolDropdownDetails";

export default function PolDropdown({
                                        className = '',
                                        summaryRender,
                                        detailsRender,
                                        detailsList = [],
                                        detailsListItemRender,
                                        detailsListItemOnClick,
                                        anchorInline = 'left',
                                        isHoverable = false,
                                        withPortal = false,
                                    }) {
    const summaryRef = useRef(null);
    const contentRef = useRef(null);
    const {
        isOpen,
        toggleIsOpen,
        isHovered,
        handleMouseEnter,
        handleMouseLeave,
        containerRef,
    } = usePolDropdown(withPortal ? contentRef : null);

    const [coords, setCoords] = useState(null);

    const updateCoords = useCallback(() => {
        if (!summaryRef.current) return;
        const rect = summaryRef.current.getBoundingClientRect();
        setCoords({
            top: rect.bottom,
            ...(anchorInline === 'right'
                ? {right: document.documentElement.clientWidth - rect.right}
                : {left: rect.left}),
        });
    }, [anchorInline]);

    useLayoutEffect(() => {
        if (!withPortal || !isOpen) return;
        updateCoords();
        window.addEventListener('scroll', updateCoords, true);
        window.addEventListener('resize', updateCoords);
        return () => {
            window.removeEventListener('scroll', updateCoords, true);
            window.removeEventListener('resize', updateCoords);
        };
    }, [withPortal, isOpen, updateCoords]);

    const content = detailsRender
        ? detailsRender({isHovered, isOpen, toggleIsOpen, detailsList})
        : <PolDropdownDetails detailsList={detailsList}
                              detailsListItemRender={detailsListItemRender}
                              detailsListItemOnClick={detailsListItemOnClick}
                              toggleIsOpen={toggleIsOpen}/>;

    return (
        <div ref={containerRef}
             className={`pol-dropdown ${className} ${isHoverable ? 'is-hoverable' : ''}`}
             onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave}>
            <div className="pol-dropdown__summary" ref={summaryRef} onClick={toggleIsOpen}>
                {summaryRender({isHovered, isOpen, toggleIsOpen})}
            </div>
            {withPortal
                ? (isOpen && createPortal(
                    <div ref={contentRef}
                         className="pol-dropdown__content pol-dropdown__content--portal is-open"
                         style={{position: 'fixed', zIndex: 1000, ...coords}}
                         onMouseEnter={handleMouseEnter}
                         onMouseLeave={handleMouseLeave}>
                        {content}
                    </div>,
                    document.body))
                : (
                    <div className={`pol-dropdown__content ${isOpen ? 'is-open' : ''}`}
                         style={{
                             ...(anchorInline === 'left' && {left: 0}),
                             ...(anchorInline === 'right' && {right: 0}),
                         }}>
                        {content}
                    </div>
                )
            }
        </div>
    )
}
